import React from 'react';
import { Modal } from 'antd';
import { Plus, Copy, Layers } from 'lucide-react';
import './AddSceneModal.scss';

interface AddSceneModalProps {
  visible: boolean;
  onClose: () => void;
  onCreateBlank: () => void;
  onDuplicate: () => void;
  hasPreviousScene: boolean;
}

export const AddSceneModal: React.FC<AddSceneModalProps> = ({
  visible,
  onClose,
  onCreateBlank,
  onDuplicate,
  hasPreviousScene,
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={480}
      className="add-scene-modal"
      centered
      closable={false}
    >
      <div className="modal-header">
        <div className="header-content">
          <div className="header-icon-wrapper">
            <Layers size={20} />
          </div>
          <div className="header-text">
            <h2 className="modal-title">Add New Scene</h2>
            <span className="modal-subtitle">Choose how to create your new scene</span>
          </div>
        </div>
        <button className="close-button" onClick={onClose} aria-label="Close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M1 13L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
      </div>

      <div className="modal-body">
        <div className="options-grid">
          <div
            className="scene-option-card"
            onClick={() => {
              onCreateBlank();
              onClose();
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onCreateBlank();
                onClose();
              }
            }}
          >
            <div className="option-icon-badge">
              <Plus size={24} strokeWidth={2} />
            </div>
            <div className="option-text">
              <h4 className="option-title">Blank Scene</h4>
              <p className="option-description">Start fresh with an empty scene</p>
            </div>
          </div>

          <div
            className={`scene-option-card ${!hasPreviousScene ? 'disabled' : ''}`}
            onClick={() => {
              if (hasPreviousScene) {
                onDuplicate();
                onClose();
              }
            }}
            role="button"
            tabIndex={hasPreviousScene ? 0 : -1}
            aria-disabled={!hasPreviousScene}
            onKeyDown={(e) => {
              if (hasPreviousScene && (e.key === 'Enter' || e.key === ' ')) {
                onDuplicate();
                onClose();
              }
            }}
          >
            <div className="option-icon-badge">
              <Copy size={22} strokeWidth={2} />
            </div>
            <div className="option-text">
              <h4 className="option-title">Duplicate Previous</h4>
              <p className="option-description">
                {hasPreviousScene 
                  ? 'Copy settings from the last scene'
                  : 'No previous scene available'
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddSceneModal;
